import { cn } from '@sohanemon/utils';
import type { HTMLAttributes } from 'react';

export interface IphoneProps extends HTMLAttributes<HTMLDivElement> {}

export function Iphone({ className, children, ...props }: IphoneProps) {
	return (
		<div
			className={cn(
				'[--radius:36px]',
				'relative inline-block h-fit w-full rounded-(--radius) border-3 leading-none',
				className,
			)}
			{...props}
		>
			<div className="rounded-[calc(var(--radius)-3px)] bg-background/90 p-2 *:rounded-[calc(var(--radius)-3px-8px)]">
				{/* Screen area */}
				{children}

				{/* Left — mute button */}
				<div
					className="absolute rounded-l-sm bg-secondary/50"
					style={{ left: -4, width: '0.7%', top: '19.39%', height: '3.74%' }}
				/>

				{/* Left — volume up */}
				<div
					className="absolute rounded-l-sm bg-secondary/50"
					style={{
						left: -4,
						width: '0.58%',
						top: '26.53%',
						height: '7.48%',
					}}
				/>

				{/* Left — volume down */}
				<div
					className="absolute rounded-l-sm bg-secondary/50"
					style={{
						left: -4,
						width: '0.58%',
						top: '36.17%',
						height: '7.48%',
					}}
				/>

				{/* Right — power button */}
				<div
					className="absolute rounded-r-sm bg-secondary/50"
					style={{ right: -2, width: '0.7%', top: '31.63%', height: '11.9%' }}
				/>

				{/* Dynamic island — pill */}
				<div className="absolute inset-0 top-4 mx-auto flex h-fit w-1/4 justify-end rounded-full bg-card p-1.5">
					<div className="size-fit rounded-full bg-primary/10 p-1">
						{/* Dynamic island — camera inner dot */}
						<div className="size-2 rounded-full bg-primary/20" />
					</div>
				</div>

				{/* Dynamic island — camera outer ring */}
			</div>
		</div>
	);
}
